export default __webpack_public_path__ + "static/media/c013-1.cb1ed90c.png";